<template>
<div>
  <template v-for="(f,i) in faces">
    <div :key="i" :style="boxStyle(f)"></div>
    <v-layout row justify-center class="ma-0" :style="labelStyle(f)">
      <v-chip dark class="elevation-3" v-if="f.Name">{{f.Name}}</v-chip>
    </v-layout>
  </template>
</div>
</template>

<script>
export default {
  name: 'FacesDetection',
  props: {
    faces: {
      type: Array
    }
  },
  methods: {
    boxStyle(box) {
      return {
        'position': 'absolute',
        'top': `${box.BoundingBox.Top*100}%`,
        'left': `${box.BoundingBox.Left*100}%`,
        'width': `${box.BoundingBox.Width*100}%`,
        'height': `${box.BoundingBox.Height*100}%`,
        'border-style': 'solid',
        'border-width': '3px',
        'border-color': box.FaceId ? 'rgba(55, 255, 55, 0.7)' : 'rgba(255, 255, 255, 0.5)'
      }
    },
    labelStyle(box) {
      return {
        'position': 'absolute',
        'left': `${box.BoundingBox.Left*100}%`,
        'width': `${box.BoundingBox.Width*100}%`,
        'top': `${(box.BoundingBox.Top+box.BoundingBox.Height)*100}%`
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cast/FacesDetection.vue